export const Languages = [
  { key: "de", pretty: "German" },
  { key: "en", pretty: "English" },
  { key: "fr", pretty: "French" },
  { key: "it", pretty: "Italian" },
  { key: "es", pretty: "Spanish" }
]